<template>
    <div
        :style="commonConfigStyles"
        class="o-modal-item-details-4"
    >
        <div class="modal-item-details-4-image-container">
            <img
                v-if="itemIcon"
                :src="itemIcon"
                class="item-icon"
            >
        </div>
        <span class="item-title">
            {{ itemName }}
        </span>
        <span class="item-categories" v-if="itemCategories">
            {{ itemCategories }}
        </span>
        <span class="item-distance">
            <svg-icon
                original
                name="icons/store-path"
                class="item-distance__icon"
            />
            {{ distanceMessage }}
        </span>
        <div class="buttons-container">
            <AButtonOtg
                class="modal-item-details-4-button modal-item-details-4-button-black"
                v-if="isDisabledFastGuide"
                @onClick="onClickFast"
            >
                <span class="button-container">
                    <span class="button-icon-container">
                        <svg-icon
                            original
                            :name="fastGuideIconPath"
                            class="button-icon"
                        />
                    </span>
                    <span>
                        {{ $t('ui.fastest-way') }}
                    </span>
                </span>
            </AButtonOtg>
            <AButtonOtg
                class="modal-item-details-4-button modal-item-details-4-button-easy"
                theme="white"
                v-if="isDisabledEasyGuide"
                @onClick="onClickEasy"
            >
                <span class="button-container button-container-easy">
                    <span class="button-icon-container">
                        <svg-icon
                            original
                            :name="easyGuideIconPath"
                            class="button-icon"
                        />
                    </span>
                    <span>
                        {{ $t('ui.accessible-way') }}
                    </span>
                </span>
            </AButtonOtg>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import AButtonOtg from '../../atoms/a-button-otg';

import {
    EASY,
    FAST
} from "../../../utils/constants/app-constants";
import  { TERMINAL_STANDARD_GUIDE } from "../../../utils/constants/pages";

export default {
    name: 'OModalItemDetails4',
    components: {
        AButtonOtg
    },
    props: {
        item: {
            type: Object,
            required: true
        },
        itemName: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapGetters([
            't',
            'getPropsMapping',
            'getCategoryById',
            'getMapConfigProp',
            'getDenormalisedObjectById'
        ]),
        itemIcon() {
            return this.t(this.item, 'icon') || '';
        },
        itemFloor() {
            if(!this.item.id) return ''

            const props = this.getPropsMapping;

            const item = this.getDenormalisedObjectById(this.item.id)

            if(this.shortFloorName) {
                return item.meta[props.floor] || item.floor && item?.floor?.meta[props.name] +' '+item?.floor?.building_index
            }

            if(this.customFloorName && item?.floor?.meta[props.name]) {
                return _.capitalize(item?.floor?.meta[props.name])
            }

            return  item.meta[props.floor] || item?.floor?.building_index ?
                _.capitalize(_.replace(item?.floor?.building_index, '_', ' ')) + ', ' +
                _.capitalize(item?.floor?.meta[props.name]) : '';
        },
        distance() {
            return this.item.distance || 0;
        },
        distanceMessage() {
            return `${this.$t('ui.distance')}: ${this.distance} meter`;
        },
        commonConfigStyles() {
            return this.getMapConfigProp('components.OModalItemDetails4.styles') || null;
        },
        commonConfigParams() {
            return this.getMapConfigProp('components.OModalItemDetails4.params') || {};
        },
        fastGuideIconPath() {
            return this.commonConfigParams.fastGuideIcon
                ? `icons/${this.commonConfigParams.fastGuideIcon}`
                : 'icons/fast-way-3-white';
        },
        easyGuideIconPath() {
            return this.commonConfigParams.easyGuideIcon
                ? `icons/${this.commonConfigParams.easyGuideIcon}`
                : 'icons/easy-way-3-black';
        },
        customFloorName() {
            return this.commonConfigParams.custom_floor_name
        },
        shortFloorName() {
            return this.commonConfigParams.short_floor_name
        },
        isDisabledGuideBtn() {
            return this.commonConfigParams.disabled_guide_btn
        },
        isDisabledFastGuide() {
            return this.t(this.item, 'fast_guide')
        },
        isDisabledEasyGuide() {
            return this.t(this.item, 'easy_guide')
        },
        itemCategories() {
            let categories = this.item.lists.categories;
            if(!categories) {
                return ''
            }
            categories = categories.map(id => {
                const category = this.getCategoryById(id)
                return this.t(category, 'name')
            }).filter(n => n)
            return categories.join(' | ')
        }
    },
    methods: {
        onClickClose() {
            this.$emit('onClose');
        },
        onClickFast() {
            this.redirectToPathFrame(FAST);
        },
        onClickEasy() {
            this.redirectToPathFrame(EASY);
        },
        redirectToPathFrame(mode) {
            const payload = {
                name: TERMINAL_STANDARD_GUIDE,
                params: {
                    itemId: this.item.id,
                    mode
                }
            };
            this.$emit('onClose')
            this.$router.replace(payload);
            this.onClickClose();
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />
